export default "__VITE_PUBLIC_ASSET__65db589e__"